<template>
  <div v-if="dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết đề nghị thanh toán</h1>
      <div style="float: right">
        <button
          v-if="['APPROVED', 'SUCCESS'].includes(detail.status)"
          @click="downloadPaymentVoucher(detail)"
          class="mr-2 font-medium f12 btn btn-outline-secondary"
        >
          Tải chứng từ chi
        </button>
        <button
          v-if="
            dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_PAY') &&
            detail.status === 'WAIT_APPROVE'
          "
          @click="openChangeKpiStatus(detail)"
          class="mr-2 font-medium f12 btn btn-outline-secondary"
        >
          Đổi tình trạng KPI
        </button>
        <button
          v-if="
            dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_PAY') && detail.status === 'APPROVED'
          "
          @click="payModal = true"
          class="mr-2 font-medium f12 btn btn-outline-secondary"
        >
          Hoàn tiền
        </button>
        <button
          v-if="
            dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_APPROVE') &&
            detail.status === 'WAIT_APPROVE'
          "
          @click="reject"
          class="mr-2 font-medium f12 btn btn-outline-secondary"
        >
          Từ chối
        </button>
        <button
          v-if="
            dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_APPROVE') &&
            detail.status === 'WAIT_APPROVE'
          "
          @click="approve"
          class="mr-2 font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Duyệt
        </button>
        <button
          @click="$router.push({ path: `/list-order` })"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-left-arrow-alt"></i> Quay lại
        </button>
      </div>
      <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="px-20 card-body form-row">
        <div class="mb-3 col-sm-6">
          <div class="form-detail">
            <h1>Thông tin phiếu đề nghị thanh toán</h1>
            <div class="form-group form-row" v-if="detail.code">
              <label for="" class="col-sm-4 col-form-label"
                >Mã đề nghị thanh toán<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.code }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.createdTime">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.refundCode">
              <label for="" class="col-sm-4 col-form-label"
                >Mã biên bản hoàn tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.refundCode }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.receiptCode">
              <label for="" class="col-sm-4 col-form-label"
                >Mã phiếu thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <a @click="openReiceipt(detail)" href="javascript:;">{{ detail.receiptCode }}</a>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngày đã thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.transactionCode">
              <label for="" class="col-sm-4 col-form-label"
                >Mã giao dịch đã thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.transactionCode }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Mã hợp đồng/ phụ lục<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <a @click="openContract(detail)" href="javascript:;">{{ detail.contractCode }}</a>
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Ngày ký<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.signTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.reason">
              <label for="" class="col-sm-4 col-form-label"
                >Lý do hoàn tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.reason | mapText(refundReason) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.refundAmount">
              <label for="" class="col-sm-4 col-form-label"
                >Số tiền hoàn<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.refundAmount | transformMoney }} VNĐ
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-4 col-form-label"
                >Tình trạng KPI<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.kpiStatus | transformData(Config.kpiStatus) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.amount">
              <label for="" class="col-sm-4 col-form-label"
                >Số tiền trên phiếu thu<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.amount | transformMoney }} VNĐ</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.status">
              <label for="" class="col-sm-4 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  <span class="badge" :class="[detail.status ? detail.status : '']">
                    {{ detail.status | mapText(statusOrder) }}
                  </span>
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.reasonReject">
              <label for="" class="col-sm-4 col-form-label"
                >Lý do từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.reasonReject }}</p>
              </div>
            </div>
            <div
              class="form-group form-row"
              v-if="detail.creator && detail.creator.name && detail.creator.email"
            >
              <label for="" class="col-sm-4 col-form-label"
                >Người tạo<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.creator.name }} - {{ detail.creator.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="['SUCCESS', 'APPROVED'].includes(detail.status)">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian duyệt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.monitorApprovedTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="['SUCCESS', 'APPROVED'].includes(detail.status)">
              <label for="" class="col-sm-4 col-form-label"
                >GS duyệt<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p v-if="detail.userApproved" class="form-control-plaintext f12">
                  {{ detail.userApproved.name }} - {{ detail.userApproved.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.status === 'REJECTED'">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.monitorRejectTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.status === 'REJECTED'">
              <label for="" class="col-sm-4 col-form-label"
                >GS từ chối<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p v-if="detail.userReject" class="form-control-plaintext f12">
                  {{ detail.userReject.name }} - {{ detail.userReject.email }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.refundNote">
              <label for="" class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.refundNote }}</p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Thông tin TKNH nhận tiền</h1>
            <div class="form-group form-row" v-if="detail.bankName">
              <label for="" class="col-sm-4 col-form-label"
                >Ngân hàng<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.bankName }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.accountNumber">
              <label for="" class="col-sm-4 col-form-label"
                >Số tài khoản<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.accountNumber }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.accountName">
              <label for="" class="col-sm-4 col-form-label"
                >Tên tài khoản<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.accountName }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.branch">
              <label for="" class="col-sm-4 col-form-label"
                >Chi nhánh<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.branch }}</p>
              </div>
            </div>
          </div>

          <div class="form-detail" v-if="detail.status === 'SUCCESS'">
            <h1>Thông tin hoàn tiền</h1>
            <div class="form-group form-row" v-if="detail.voucherCode">
              <label for="" class="col-sm-4 col-form-label"
                >Mã chứng từ chi<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.voucherCode }}</p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.bankPayment">
              <label for="" class="col-sm-4 col-form-label"
                >Ngân hàng chi<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.bankPayment | mapText(listBank) }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.paymentTime">
              <label for="" class="col-sm-4 col-form-label"
                >Thời gian chi tiền<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ detail.paymentTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </div>
            </div>
            <div class="form-group form-row" v-if="detail.note">
              <label for="" class="col-sm-4 col-form-label"
                >Ghi chú<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ detail.note }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-1 mb-3 col-sm-6">
          <h6
            v-if="
              (detail.imageRefunds && detail.imageRefunds.length > 0) ||
              (detail.imagePayments && detail.imagePayments.length > 0)
            "
          >
            Ảnh
          </h6>
          <div class="mb-2" v-if="detail.imageRefunds && detail.imageRefunds.length > 0">
            <i>Ảnh biên bản hoàn tiền</i>
          </div>
          <div
            class="form-group row img-list mr-0 ml-0"
            v-if="detail.imageRefunds && detail.imageRefunds.length > 0"
          >
            <ul v-viewer>
              <li v-for="(item, index) in detail.imageRefunds" :key="index">
                <a href="javascript:void(0)">
                  <img :src="item" />
                </a>
              </li>
            </ul>
          </div>

          <div class="mb-2" v-if="detail.imagePayments && detail.imagePayments.length > 0">
            <i>Ảnh thông tin chi tiền</i>
          </div>
          <div
            class="form-group row img-list mr-0 ml-0"
            v-if="detail.imagePayments && detail.imagePayments.length > 0"
          >
            <ul v-viewer>
              <li v-for="(item, index) in detail.imagePayments" :key="index">
                <a href="javascript:void(0)">
                  <img :src="item" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <b-modal v-model="payModal" centered size="lg">
          <template #modal-header="{ close }">
            <h5>Thông tin chi tiền hoàn</h5>
            <b-button
              size="sm"
              variant="light"
              @click="
                close(), (reqPay = { imagePayments: [] }), (paymentTime = null), (payModal = false)
              "
            >
              x
            </b-button>
          </template>
          <ValidationObserver class="w-100" ref="formPay">
            <form @submit.prevent="checkValidate">
              <div class="row">
                <div class="col-md-6">
                  {{ reqPay.paymentTime }}
                  <ValidationProvider
                    rules="required|minMaxName_7"
                    vid="voucherCode"
                    name="Mã chứng từ chi"
                  >
                    <div class="form-group row" slot-scope="{ errors }">
                      <label for="" class="col-sm-4 col-form-label"
                        >Mã chứng từ chi<span style="color: red"> *</span></label
                      >
                      <div class="col-sm-8">
                        <input v-model.trim="reqPay.voucherCode" />
                        <p class="text-danger">{{ errors[0] }}</p>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider rules="required" vid="bankPayment" name="Tên ngân hàng">
                    <div class="form-group row" slot-scope="{ errors }">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngân hàng chi<span style="color: red"> *</span></label
                      >
                      <div class="col-sm-8">
                        <Select2 :options="listBank" v-model="reqPay.bankPayment"></Select2>
                        <p class="text-danger">{{ errors[0] }}</p>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider rules="required" vid="paymentTime" name="Thời gian chi">
                    <div class="form-group row" slot-scope="{ errors }">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian chi<span style="color: red"> *</span></label
                      >
                      <div class="col-sm-8">
                        <date-picker v-model="paymentTime" :config="configPicker"></date-picker>
                        <p class="text-danger">{{ errors[0] }}</p>
                      </div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider rules="minMaxName_1" vid="note" name="Ghi chú">
                    <div class="form-group row" slot-scope="{ errors }">
                      <label for="" class="col-sm-4 col-form-label">Ghi chú</label>
                      <div class="col-sm-8">
                        <input v-model="reqPay.note" />
                        <p class="text-danger">{{ errors[0] }}</p>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>
                <div class="col-md-6">
                  <h6>Upload ảnh</h6>
                  <div class="form-group img-list">
                    <ul class="m-0">
                      <li v-for="(item, index) in reqPay.imagePayments" :key="index">
                        <a href="#popup-slider" data-toggle="modal">
                          <img :src="item" />
                          <span @click="removeImg(index)">
                            <i class="bx bx-trash bx-sm"></i>
                          </span>
                        </a>
                      </li>
                      <li>
                        <div
                          v-if="loadingImage"
                          class="add-img d-flex align-content-center justify-content-center"
                        >
                          <div class="text-center">
                            <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                          </div>
                        </div>
                        <div
                          v-else-if="reqPay.imagePayments && reqPay.imagePayments.length < 10"
                          class="add-img"
                        >
                          <span class="text-center bx bx-plus"></span>
                          <input
                            type="file"
                            ref="fileImgPay"
                            accept="image/jpeg, image/png"
                            @input="onSelectFile"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </ValidationObserver>
          <template #modal-footer="{}">
            <b-button variant="primary" @click="checkValidate"> Đồng ý </b-button>
          </template>
        </b-modal>

        <b-modal v-model="kpiStatusModal" ignore-enforce-focus-selector="input" centered size="md">
          <template #modal-header="{ close }">
            <h5>Đổi tình trạng KPI</h5>
            <b-button size="sm" variant="light" @click="close()">x</b-button>
          </template>
          <form @submit.prevent="changeKpiStatus">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Tình trạng KPI</label>
              <div class="col-sm-8">
                <Select2 :options="Config.kpiStatus" v-model="kpiStatusValue"></Select2>
              </div>
            </div>
          </form>
          <template #modal-footer="{}">
            <b-button variant="primary" @click="changeKpiStatus"> Đồng ý </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ReceiptService } from '@/services/receipts.service'
  import { BankService } from '@/services/bank.service'
  import { CommonService } from '@/services/common.service'
  import Config from '@/thirdParty/config'
  import datePicker from 'vue-bootstrap-datetimepicker'
  import moment from 'moment'
  // import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  export default {
    data() {
      return {
        Config,
        showLoading: false,
        id: this.$route.params.id,
        detail: {},
        refundReason: [
          { id: 'SOFTWARE_DEVICE', text: 'Hoàn tiền thiết bị/phần mềm' },
          { id: 'RENT_LEND', text: 'Hoàn tiền cọc cho thuê/cho mượn' },
          { id: 'CONTRACT_COINCIDENCE', text: 'Hoàn tiền do thanh toán trùng hợp đồng' },
        ],
        statusOrder: Config.paymentOrderStatus,
        listBank: [],
        reqPay: {
          imagePayments: [],
        },
        loadingImage: false,
        payModal: false,
        kpiStatusModal: false,
        kpiStatusValue: null,
        paymentTime: null,
        configPicker: {
          format: 'HH:mm DD/MM/YYYY',
          useCurrent: true,
        },
      }
    },
    created() {
      this.fetchData()
      this.getListBank()
    },
    components: {
      datePicker,
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const data = await ReceiptService.detailOrder({
            id: this.id,
          })
          if (data.success) {
            this.detail = data.data
          }
        } catch (err) {
        } finally {
          this.showLoading = false
        }
      },
      async reject() {
        const { value: flag, note } = await this.rejectMx()
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await ReceiptService.rejectOrder({ id: this.id, reason: note })
            if (res.success) {
              await this.fetchData()
              this.showSuccessMx('Từ chối thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },
      openChangeKpiStatus(data) {
        this.kpiStatusValue = data.kpiStatus ?? Config.kpiStatus[0].id
        this.kpiStatusModal = true
      },
      async changeKpiStatus() {
        try {
          this.showLoading = true
          const res = await ReceiptService.changeKpiStatus({
            id: this.id,
            kpiStatus: this.kpiStatusValue,
          })
          if (res.success) {
            await this.fetchData()
            this.showSuccessMx('Đổi tình trạng KPI thành công')
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
          this.kpiStatusModal = false
        }
      },
      async approve() {
        try {
          this.showLoading = true
          const res = await ReceiptService.approveOrder({
            id: this.id,
          })
          if (res.success) {
            await this.fetchData()
            this.showSuccessMx('Duyệt thành công')
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      async downloadPaymentVoucher(item) {
        try {
          this.showLoading = true
          const data = await ReceiptService.getPaymentVoucher(item.id)
          await ReceiptService.genPaymentVoucher(data.data)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      async getListBank() {
        try {
          const data = await BankService.listBank()
          if (data.success) {
            this.listBank = data.data.map(e => {
              return {
                id: e.id,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async onSelectFile() {
        const input = this.$refs.fileImgPay
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0])
      },
      removeImg(index) {
        this.reqPay.imagePayments.splice(index, 1)
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqPay.imagePayments.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      async checkValidate() {
        const isSuccess = await this.$refs.formPay.validate()
        if (!isSuccess) {
          return
        }
        this.reqPay.paymentTime = moment(this.paymentTime, this.configPicker.format).valueOf()
        this.reqPay.orderPaymentId = this.id
        this.payOrder()
      },
      async payOrder() {
        try {
          this.showLoading = true
          const data = await ReceiptService.payOrder(this.reqPay)
          if (data.success) {
            this.payModal = false
            this.showSuccessMx('Hoàn tiền thành công')
            await this.fetchData()
          } else {
            this.showFailMx(data.message)
          }
        } catch (e) {
        } finally {
          this.showLoading = false
        }
      },
      openReiceipt(data) {
        window.open(`/detail-receipts/${data.receiptId}`)
      },
      openContract(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.contractId)}`, '_blank')
          } else {
            window.open(
              `/sales-manager/detail-paper/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(
              `/contract-detail-ecommerce/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.contractId)}`, '_blank')
          }
        }
      },
    },
    filters: {
      mapText(data, listState) {
        if (!data) return
        const text = listState.filter(e => e.id === data)
        return text.length > 0 ? text[0].text : ''
      },
    },
  }
</script>

<style></style>
